import React from "react";
import "./spinner.css"; // Certifique-se de ajustar o caminho conforme necessário

const Spinner = () => {
  return (
    <div className="flex justify-center items-center">
      <div className="spinner"></div>
    </div>
  );
};

export default Spinner;
